import { MutationTree } from 'vuex';

import { State } from './state';
import { MenuMutationTypes } from './mutation-types';

export type Mutations<S = State> = {
  [MenuMutationTypes.SET_OBRA](state: S, obra: object): void;
  [MenuMutationTypes.SET_CONTRATO](state: S, contrato: number): void;
  [MenuMutationTypes.SET_CONTRATOS_USUARIO](state: S, contratos: any[]): void;
  [MenuMutationTypes.SET_OBRAS_USUARIO](state: S, obras: any[]): void;
};

export const mutations: MutationTree<State> & Mutations = {
  [MenuMutationTypes.SET_OBRA](state: State, obra: object) {
    state.obraSelecionada = obra;
    sessionStorage.setItem('obraSelecionada', JSON.stringify(obra));
    localStorage.setItem('ultimaObraSelecionada', JSON.stringify(obra));
  },
  [MenuMutationTypes.SET_OBRAS_USUARIO](state: State, obras: any[]) {
    state.obrasUsuario = obras;
  },
  [MenuMutationTypes.SET_CONTRATO](state: State, contrato: number) {
    state.codigoContrato = contrato;
    sessionStorage.setItem('codigoContrato', JSON.stringify(contrato));
    localStorage.setItem('ultimoCodigoContratoSelecionado', JSON.stringify(contrato));
  },
  [MenuMutationTypes.SET_CONTRATOS_USUARIO](state: State, contratos: any[]) {
    state.contratosUsuario = contratos;
  }
};
